import { ToastPosition } from 'react-toastify';

export const toastFormConfig = {
  position: 'top-left' as ToastPosition,
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
};
